<template>
  <va-card :title="$t('menu.checkouts') + ' ' + $t('tables.loads.code') + ' ' + this.$route.params.loadCode">
    <va-button
      v-if="this.$route.params.backAction == 1"
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'loads', params: {
        current_page: this.$route.params.current_page, 
        search: this.$route.params.search, 
        delivery_date: this.$route.params.delivery_date, 
        perPage: this.$route.params.perPage }
        }"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-button
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      :to="{ name: 'loads_finished' }"
    >
      {{ $t('menu.back') }}
    </va-button>

    <va-data-table 
      :fields="fields" 
      :data="data" 
    >
    <template slot="actions">
      <va-button
        small
        inline
        color="green"
        icon="fa fa-edit"
        class="mr-1"
        @click="showConfirmResendCheckout = true, loadIdCheck = this.$route.params.loadId" 
      >
        {{ $t('menu.resend') }}
      </va-button>
    </template>
    </va-data-table>

    <va-modal
      v-model="showConfirmResendCheckout"
      size="small"
      :title="$t('modal.confirm')"
      :message="$t('modal.messageConfirmResendCheckout')"
      hideDefaultActions
      :color="this.$themes.secondary"
    >

      <va-button
        color="danger"
        class="ma-2"
        @click="showConfirmResendCheckout = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="green"
        class="ma-2"
        @click="resendCheckout(), showConfirmResendCheckout = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>

  </va-card>
</template>

<script>
import LoadChecksAPI from '@/services/LoadChecksAPI'
import { mapState } from "vuex";

export default {
  data () {
    return {
      data: [],
      loadId: '',
      showConfirmResendCheckout: false,

    }
  },
  
  channels: {
    NeedRefreshOrders: {
      received(data) {
        this.getAllOrdersByLoad();
      },
    }
  },

  mounted () {
    this.$cable.subscribe({ channel: 'NeedRefreshOrders', company: this.currentUser.company })
    this.getLoadChecksbyLoadId();
  },
  methods: {
    getLoadChecksbyLoadId() {
      this.loadId = this.$route.params.loadId
      this.load = this.$route.params.code
      
      LoadChecksAPI.getLoadChecksbyLoadId(this.loadId).then(response => {
        this.data = response.data.load_checks
      })
    },
    async resendCheckout () {
      this.loadId = this.$route.params.loadId

      await LoadChecksAPI.resendCheckout(this.loadId, true).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
  },
  computed: {
    ...mapState(['currentUser']),

    fields () {
      return [
        {
          name: 'orders_quantity',
          title: this.$t('tables.load_checks.orders_quantity'),
          width: '3%',
        },
        {
          name: 'plates_quantity',
          title: this.$t('tables.load_checks.plates_quantity'),
          width: '3%',
        },
        {
          name: 'packages_quantity',
          title: this.$t('tables.load_checks.packages_quantity'),
          width: '3%',
        },
        {
          name: 'seal_code_01',
          title: this.$t('tables.load_checks.seal_code_01'),
          width: '3%',
        },
        {
          name: 'seal_code_02',
          title: this.$t('tables.load_checks.seal_code_02'),
          width: '3%',
        },
        {
          name: 'check_type',
          title: this.$t('tables.load_checks.check_type'),
          width: '5%',
        },
        {
          name: 'user_login',
          title: this.$t('tables.load_checks.user_login'),
          width: '3%',
        },
        {
          name: 'user_name',
          title: this.$t('tables.load_checks.user_name'),
          width: '5%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          width: '5%',
        }
      ]
    },
  }
}
</script>